const CookieConsentConfig = {
	guiOptions: {
		consentModal: {
			layout: 'box wide',
			position: 'bottom left',
			equalWeightButtons: true,
			flipButtons: false,
		},
		preferencesModal: {
			layout: 'box',
			position: 'right',
			equalWeightButtons: true,
			flipButtons: false,
		},
	},
	categories: {
		necessary: {
			readOnly: true,
		},
		analytics: {},
	},
	language: {
		default: 'fr',
		translations: {
			fr: {
				consentModal: {
					title: 'Nous utilisons des cookies',
					description:
						'Les cookies sont utilisés sur ce site pour améliorer votre navigation et vous offrir la meilleure expérience utilisateur possible. En cliquant sur « Tout accepter », vous consentez à l’utilisation des cookies.',
					acceptAllBtn: 'Tout accepter',
					acceptNecessaryBtn: 'Tout rejeter',
					showPreferencesBtn: 'Gérer les préférences',
				},
				preferencesModal: {
					title: 'Centre de préférence des cookies',
					acceptAllBtn: 'Tout accepter',
					acceptNecessaryBtn: 'Tout rejeter',
					savePreferencesBtn: 'Sauvegarder les préférences',
					closeIconLabel: 'Fermer la modale',
					serviceCounterLabel: 'Services',
					sections: [
						{
							title: 'Utilisation des cookies',
							description:
								'Les cookies sont utilisés sur ce site pour améliorer votre navigation et vous offrir la meilleure expérience utilisateur possible. En cliquant sur « Tout accepter », vous consentez à l’utilisation des cookies.',
						},
						{
							title: 'Cookies strictement nécessaires <span class="pm__badge">Toujours activé</span>',
							description:
								'Ces cookies permettent le fonctionnement de base du site (navigation, sécurité, préférences de consentement, likes d’établissements). Ils ne peuvent pas être désactivés.',
							linkedCategory: 'necessary',
						},
						{
							title: 'Statistiques et audience',
							description:
								'Ces cookies mesurent l’audience du site afin de comprendre comment les pages sont utilisées. Ils ne sont déposés qu’avec votre accord.',
							linkedCategory: 'analytics',
						},
					],
				},
			},
		},
	},
};

export default CookieConsentConfig;
